import { observer } from 'mobx-react';

import { CheckboxGroupInput } from '../../Form';
import { ErrorMessages } from '../Input/ErrorMessages/ErrorMessages';
import Label from '../Label/Label';
import CheckboxElement from './CheckboxElement';

type CheckboxGroupProps = {
  label?: string;
  input: CheckboxGroupInput;
};

const CheckboxGroup = observer(({ label, input }: CheckboxGroupProps) => {
  return (
    <div>
      {label && <Label>{label}</Label>}
      {input.availableValues.map((checkboxOption) => (
        <CheckboxElement
          key={checkboxOption.value}
          onChange={() => input.handleCheckboxChange(checkboxOption.value)}
          checked={input.isChecked(checkboxOption.value)}
          size="large"
        >
          {checkboxOption.label}
        </CheckboxElement>
      ))}
      <ErrorMessages errors={input.validationErrorMessages} />
    </div>
  );
});

export default CheckboxGroup;
